import React from 'react';
import { Shield } from 'lucide-react';

export function CookieConsentBar({ t, handleCookieChoice }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-md border-t border-slate-700 px-4 py-4 sm:px-6">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
        <Shield className="w-5 h-5 text-emerald-400 shrink-0 hidden sm:block" />
        <div className="flex-1">
          <div className="text-sm font-medium mb-1">{t('cookieTitle')}</div>
          <div className="text-xs text-slate-400">{t('cookieText')}</div>
        </div>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={() => handleCookieChoice(false)}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm border border-slate-600 text-slate-300 hover:bg-slate-800 transition-colors"
          >
            {t('cookieDecline')}
          </button>
          <button
            onClick={() => handleCookieChoice(true)}
            className="flex-1 sm:flex-none px-4 py-2 rounded-lg text-sm bg-emerald-500 hover:bg-emerald-600 font-medium transition-colors"
          >
            {t('cookieAccept')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBar;
